import * as yup from 'yup';

export const flowsModify = yup.object().shape({
  name: yup.string().required().min(1).label("Can't be empty"),
});
